function Loading() {
  return (
    <img className="dice" alt="rolling-dice" src="./images/dice.gif" />
  )
}  

export default Loading
